"use strict";
exports.__esModule = true;
exports.HASH_SIZE = 81;
exports.TRANSACTION_TRYTES_SIZE = 2673;
exports.SIGNATURE_MESSAGE_FRAGMENT_TRYTES_SIZE = 2187;
exports.TAG_TRYTES_SIZE = 27;
exports.OBSOLETE_TAG_TRYTES_SIZE = 27;
exports.NONCE_TRYTES_SIZE = 27;
//# sourceMappingURL=constants.js.map